import React from 'react'

const Badge = props => (
  <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 22.9"
  >
    <defs>
      <clipPath id="badge1_a">
        <circle cx="11.8" cy="11.5" r="8" fill="none" />
      </clipPath>
      <clipPath id="badge1_b">
        <path
          d="M14.7 13h-.9a1.6 1.6 0 0 1 0 3.3h1a1.6 1.6 0 0 0 0-3.3z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge1_c">
        <path
          d="M12.3 13h-1a1.6 1.6 0 1 1 0 3.3h1a1.6 1.6 0 1 0 0-3.3z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Warstwa 2">
      <path
        d="M11.7.5c.2 0 .6-.5 1-.5s.5.6.8.6.7-.4 1-.3.5.7.7.7.8-.3 1-.2.4.8.7.9.8-.1 1 0 .3.8.5 1 .8 0 1 .2.1.8.3 1 .8.2 1 .4 0 .8.1 1 .8.3 1 .5-.2.9 0 1 .7.5.8.8-.3.7-.2 1 .6.5.7.8-.4.7-.4 1 .5.6.5.9-.5.6-.5.9.5.7.4 1-.6.5-.7.8.4.8.3 1-.7.4-.8.7.2.8 0 1-.7.4-.9.6 0 .8 0 1-.9.2-1 .4-.2.9-.4 1-.8 0-1 .2-.2.9-.4 1-.8 0-1 .1-.4.8-.7.9-.8-.2-1-.1-.5.6-.8.7-.7-.3-1-.3-.5.6-.8.7-.7-.5-1-.5-.7.5-1 .5-.5-.6-.8-.6-.8.3-1 .3-.5-.7-.8-.8-.8.3-1 .2-.4-.7-.6-.9-.8.1-1 0-.3-.8-.5-1-.9 0-1-.1-.1-.8-.3-1-.8-.2-1-.4 0-.8-.2-1-.7-.3-.9-.5.2-.8 0-1-.7-.5-.8-.7.3-.8.2-1-.6-.6-.7-.8.4-.8.4-1-.6-.7-.6-1 .6-.6.6-.9-.5-.7-.4-1S1 9.2 1 9 .8 8.1 1 8s.7-.4.8-.7-.2-.8 0-1 .7-.3.9-.6 0-.8 0-1 .9-.2 1-.4.1-.8.3-1 .9 0 1-.2.3-.8.5-1 .8.1 1 0 .4-.8.6-1 .8.3 1 .2.5-.7.8-.8.7.4 1 .3.6-.6.8-.6l1 .4z"
        fill="#00b4ff"
      />
      <circle cx="11.8" cy="11.5" r="10.9" fill="#00b4ff" />
      <path
        d="M20 11.5a8.3 8.3 0 1 1-8.2-8.3 8.3 8.3 0 0 1 8.3 8.3z"
        fill="#fff"
      />
      <path
        d="M19.7 11.5a7.9 7.9 0 1 1-7.9-7.9 7.9 7.9 0 0 1 7.9 7.9zM7.3 3l.4-.2.3.5a1.3 1.3 0 0 1-.3.2.5.5 0 0 1-.4 0 .6.6 0 0 1-.3-.2.5.5 0 0 1 0-.4.5.5 0 0 1 .3-.3H7.6v.1a.5.5 0 0 0-.2 0 .3.3 0 0 0-.2.2.4.4 0 0 0 0 .3.5.5 0 0 0 .2.1.2.2 0 0 0 .2 0V3h-.1zM8.3 2.8l.2.3-.3.1-.3-1h.3c.2-.1.4 0 .4.1a.3.3 0 0 1 0 .3L9 3l-.3.1-.3-.3zm0-.2v-.2c0-.2 0 0-.1 0zM9.7 2.7v-.2l-.4.1v.2H9v-1h.4l.6.9zm-.2-.4L9.2 2V2a.7.7 0 0 0 0 .1v.3zM10.6 2.5h-.3l-.1-.7h-.3v-.2l.8-.1v.2h-.3zM11.8 1.5V2a.4.4 0 0 1-.1.3.5.5 0 0 1-.3 0 .4.4 0 0 1-.4 0 .3.3 0 0 1 0-.3v-.6h.3v.6a.3.3 0 0 0 0 .1.2.2 0 0 0 .2 0 .3.3 0 0 0 0-.1v-.6zM12 2.5v-1h.3v.7h.4v.3zM13.5 2.6v-.2h-.3l-.1.2h-.3l.5-1h.3l.2 1zm0-.4V2v-.2l-.2.4zM14.5 2a.2.2 0 0 0-.1 0 .4.4 0 0 0-.1.3v.3h.4l-.1.2a.5.5 0 0 1-.3 0 .5.5 0 0 1-.3-.2.6.6 0 0 1 0-.4.6.6 0 0 1 .1-.2.3.3 0 0 1 .2-.1.5.5 0 0 1 .3 0 .7.7 0 0 1 .3.1l-.2.2zM14.6 3.2h-.1V3h.2a.2.2 0 0 0 0-.1l.4-.9.3.1-.3.9a.5.5 0 0 1-.2.3.3.3 0 0 1-.3 0zM15.8 3.4l-.5-.2.4-1 .5.3v.2l-.3-.1-.1.1.3.1-.1.2-.3-.1V3l.3.2zM16 3.4a.1.1 0 0 1 .2 0 .1.1 0 0 1 0 .1.1.1 0 0 1-.1 0 .1.1 0 0 1-.1 0 .1.1 0 0 1 0-.1zm.3 0l-.2-.2.3-.6.3.2zM7.7 20.8l-.3-.2v-.8a2 2 0 0 1-.1.3l-.2.4-.2-.1.4-1 .3.2v.8l.1-.2.2-.4h.2zM8.5 21V21l-.3-.1v.1h-.3l.6-.9.3.1v1zm0-.3v-.2a1 1 0 0 1 0-.1v-.2.1l-.2.3zM10 20.5l-.1.5a.4.4 0 0 1-.2.3.5.5 0 0 1-.3 0A.5.5 0 0 1 9 21a.4.4 0 0 1 0-.3l.1-.6h.3l-.1.6a.4.4 0 0 0 0 .2h.2l.2-.6zM10.9 21.6h-.3l-.1-.5h-.1v.4H10l.1-1h.3l-.1.5.1-.1.2-.3h.3l-.3.4zM11.7 21.6v-.2h-.4v.2H11l.3-1h.4l.3 1zm-.1-.4v-.1a1 1 0 0 1 0-.2 1 1 0 0 0 0-.1.9.9 0 0 1 0 .1l-.1.3zM12.5 22h-.2v-.3h.2a.2.2 0 0 0 0-.1l-.1-1h.3v1a.5.5 0 0 1 0 .2.3.3 0 0 1-.2.1zM13.6 21.4v-.1h-.3v.2H13l.1-1h.4l.5.9zm-.1-.3v-.2a.7.7 0 0 0-.1-.1.5.5 0 0 1 0-.1v.4z"
        fill="#fff"
      />
      <path
        d="M14.8 21.2l-.8.2v-.2l.3-.7-.4.1v-.2l.7-.2v.2l-.3.7.4-.1z"
        fill="#fff"
      />
      <path
        d="M15.6 20.4a.5.5 0 0 1 0 .4.5.5 0 0 1-.3.2l-.3.1-.4-.9.4-.1a.5.5 0 0 1 .3 0 .4.4 0 0 1 .3.3zm-.3 0a.3.3 0 0 0-.1-.1.2.2 0 0 0-.2 0l.2.5a.2.2 0 0 0 .1-.1.4.4 0 0 0 0-.3zM16 20v-.4l.3-.1v.7l.1.3-.2.1-.2-.3-.6-.4.3-.1z"
        fill="#fff"
      />
      <g clip-path="url(#badge1_a)">
        <path fill="#f2f2f2" d="M0 1.3h23.6v13.4H0z" />
        <circle cx="11.8" cy="11.5" r="8" fill="#fff" />
        <path fill="#fbc53b" d="M21.7 13H2V3h19.8v10z" />
        <path
          fill="#fff"
          d="M14.9 5.2L20 9.9v3L3 13.5 2.5 11l8.2-4.4 1.3.3L14.8 5z"
        />
        <path
          fill="#e6e6e6"
          d="M14.8 5.5l4.8 4.4v2.7l-16 .5-.4-2.2 7.7-4 1.2.2 2.7-1.6z"
        />
        <path
          d="M1.6 11l.2-.1.1.1zm.6-.2l-.1-.1.3-.1zm.5-.3l.2-.2v.1zm.5-.2V10l.2-.1v.1zm.5-.3v-.1l.2-.2.1.2zm.5-.3v-.1l.2-.1.1.1zm.6-.2l-.1-.2.3-.1v.1zm.5-.3V9l.2-.2V9zm.5-.3v-.1l.2-.2v.2zm.5-.2v-.2l.2-.1v.1zm.6-.3l-.1-.1L7 8v.1zm.5-.3L7.3 8l.3-.1V8zm.5-.3v-.1l.2-.1v.1zm.5-.2v-.2l.2-.1v.1zm.5-.3v-.1L9 7v.1zm.6-.3l-.1-.1.3-.2V7zm.5-.3l.2-.2v.1zm1.9-.1l-.3-.1v-.1h.3zm.3 0v-.1l.2-.2v.1zm-1.7-.1v-.1l.2-.2v.1zm.8 0l-.3-.2h.3zm1.4-.3h-.1l.2-.2.1.1zm.5-.3H13l.2-.2h.1zm.5-.3l-.1-.1.2-.2.1.2zm.5-.3l-.1-.1.2-.2.1.1z"
          fill="#fff"
        />
        <rect
          x="18.1"
          y="12.8"
          width="2.8"
          height=".3"
          rx=".1"
          fill="#662d91"
        />
        <path fill="#f2f2f2" d="M19.7 9.7h-.4l-.8 3h2l-.8-3z" />
        <path
          fill="#93278f"
          d="M18.8 11.6h1.4l-.2-.8h-1l-.2.8zM20 10.4l-.3-.7h-.4l-.2.7h.8zM20.4 12h-1.7l-.2.8h2l-.1-.8z"
        />
        <rect
          x="18.1"
          y="11.8"
          width="2.8"
          height=".3"
          rx=".1"
          fill="#662d91"
        />
        <path fill="#f2f2f2" d="M19.7 8.8h-.4l-.8 3h2l-.8-3z" />
        <path
          fill="#93278f"
          d="M18.8 10.6h1.4l-.2-.8h-1l-.2.8zM20 9.4l-.3-.6h-.4l-.2.6h.8zM20.4 11h-1.7l-.2.8h2l-.1-.8z"
        />
        <rect
          x="15.3"
          y="12.8"
          width="1.2"
          height=".1"
          rx=".1"
          fill="#662d91"
        />
        <path fill="#f2f2f2" d="M16 11.5h-.2l-.3 1.3h.9l-.4-1.3z" />
        <path
          fill="#93278f"
          d="M15.6 12.3h.7l-.2-.4h-.4v.4zM16.1 11.8v-.3H15.7v.3h.3zM16.3 12.4h-.7l-.1.4h.9l-.1-.4z"
        />
        <rect
          x="7.7"
          y="8"
          width=".6"
          height=".1"
          rx="0"
          transform="rotate(-28.4 8 8)"
          fill="#fff"
        />
        <path fill="#fff" d="M7.8 7.4h-.1l.1.7L8 8l.2-.1-.4-.5z" />
        <path fill="#fff" d="M7.8 7.8H8v-.2h-.3V8zM7.8 7.5h-.1v.1h.1z" />
        <path fill="#fff" d="M8 7.8l-.2.1v.2L8 8l.2-.1-.1-.1z" />
        <rect
          x="15.7"
          y="6.2"
          width=".6"
          height=".1"
          rx="0"
          transform="rotate(41.2 16 6.2)"
          fill="#fff"
        />
        <path fill="#fff" d="M16.5 5.7h-.1l-.5.3.1.2h.2l.3-.5z" />
        <path
          fill="#fff"
          d="M16 5.9l.3.2V5.8H16zM16.4 5.8v-.1h-.1l.1.1zM16.3 6.2l-.3-.3-.1.1.1.2h.2z"
        />
        <path fill="#f8ad3c" d="M10 9.9V4.3L7.4 5.8l2.6 1" />
        <rect x="2.9" y="13.7" width="5.6" height=".6" rx=".3" fill="#662d91" />
        <path fill="#f2f2f2" d="M6 7.7h-.7l-1.7 6h4.2L6 7.6z" />
        <path
          fill="#93278f"
          d="M4.2 11.3h2.9l-.5-1.6h-2l-.4 1.6zM6.4 8.9l-.3-1.3h-.8L4.9 9h1.5zM7.3 12.1H4l-.4 1.5h4.2l-.5-1.5z"
        />
        <path
          d="M20.8 17h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.1 0h-.5a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.5a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.2 0H18a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.1.1zm-1.2 0H17a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .1.2.1.1 0 0 1 0 .1zm-1.2 0h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zM15 17h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.2 0h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.2 0h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.2 0H11a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.2 0h-.4a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.1 0h-.5a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.5a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.2 0h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.2 0h-.4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h.4a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.2 0h-.4a.1.1 0 0 1-.1-.2.1.1 0 0 1 .1-.1h.5a.1.1 0 0 1 .1.1.1.1 0 0 1-.2.2zm-1.1 0h-.5a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h.5a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zM21.3 15.1a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-.8 0h-1.2a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h1.2a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-2 0h-1a.1.1 0 0 1-.2-.1.1.1 0 0 1 .1-.2h1.2a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-1.8 0h-1.2a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h1.2a.1.1 0 0 1 .1.2.1.1 0 0 1-.1.1zm-2 0h-1.1a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.2h1.1a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-1.9 0h-1.2a.1.1 0 0 1-.1-.1.1.1 0 0 1 .1-.2h1.2a.1.1 0 0 1 .2.2.1.1 0 0 1-.2.1zm-2 0h-1a.1.1 0 0 1-.2-.1.1.1 0 0 1 .1-.1H11a.1.1 0 0 1 .1.1.1.1 0 0 1-.1.1zm-1.8 0H7.8a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.1H9a.1.1 0 0 1 .1.1.1.1 0 0 1-.1.1zm-2 0H5.9a.1.1 0 0 1-.2-.1.1.1 0 0 1 .2-.1H7a.1.1 0 0 1 .1.1.1.1 0 0 1-.1.1zm-2 0H4a.1.1 0 0 1-.2-.1.1.1 0 0 1 .1-.1h1.2a.1.1 0 0 1 .2.1.1.1 0 0 1-.2.1zM24 13.6h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0H22v-.1h.3v.1zm-.5 0h-.3-.1v-.1h.4v.1zm-.6 0h-.3-.1v-.1h.3v.1zm-.6 0h-.3-.1v-.1h.4v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0H19v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.2-.1v-.1h.4l-.1.1zm-.5 0H16v-.1h.3v.1zm-.6 0h-.3-.1v-.1h.4v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0H12h-.1v-.1h.4l-.1.1zm-.5 0h-.3-.1v-.1h.4v.1zm-.6 0h-.3-.1v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3-.1v-.1h.4v.1zm-.6 0H9v-.1h.3v.1zm-.6 0h-.3v-.1h.3v.1zm-.6 0h-.3v-.1h.4l-.1.1zm-.6 0h-.3v-.1h.3v.1zm-.5 0h-.4v-.1H7v.1z"
          fill="#b3b3b3"
        />
        <path
          d="M14.7 16.3a1.6 1.6 0 0 0 0-3.3h-4.1a1.6 1.6 0 0 0 0 3.3"
          fill="#53678e"
        />
        <path
          d="M13.8 16.3a1.6 1.6 0 0 0 0-3.3H9.6a1.6 1.6 0 1 0 0 3.3"
          fill="#236"
        />
        <g clip-path="url(#badge1_b)" fill="#236">
          <path d="M13.8 13h3.3v.3h-3.3zM13.8 13.6h3.3v.3h-3.3zM13.8 14.1h3.3v.3h-3.3zM13.8 14.6h3.3v.3h-3.3zM13.8 15.1h3.3v.3h-3.3zM13.8 15.7h3.3v.3h-3.3zM13.8 16.2h3.3v.3h-3.3z" />
        </g>
        <path
          d="M15 14.6h-.2a.7.7 0 0 0 0-.2l.1-.2V14h-.4v-.4h-.2v.1H14v-.2h-.2v.2H13.5l-.1-.1h-.2v.4L13 14h-.2V14.3a.7.7 0 0 0 0 .2h-.2v.2h.2a.6.6 0 0 0 0 .1.1.1 0 0 1 0 .1V15.2h.4l-.1.2v.1h.5v.1h.2v-.2h.2l.2.2h.1V15h.4v-.2a.6.6 0 0 0 0-.2h.1v-.2h.2z"
          fill="#556289"
        />
        <rect x="9.2" y="14.2" width="5.1" height=".9" rx=".1" fill="#556289" />
        <circle cx="13.8" cy="14.7" r=".5" fill="#236" />
        <rect
          x="14.4"
          y="12.3"
          width="2.9"
          height="1.7"
          rx=".8"
          fill="#f18c2d"
        />
        <rect x="15" y="12.3" width="2.7" height="1.7" rx=".8" fill="#f8ad3c" />
        <rect
          x="15.2"
          y="12.5"
          width="2.2"
          height="1.2"
          rx=".6"
          fill="#f0f9fe"
        />
        <path
          d="M15.8 13.4a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3h.2v.6zM16.7 13.4a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3h.2v.6z"
          fill="#c5d2eb"
        />
        <circle cx="16.9" cy="13.1" r=".3" fill="#236" />
        <circle cx="15.9" cy="13.1" r=".3" fill="#236" />
        <rect x="11.7" y="11.7" width="3" height="2.2" rx=".1" fill="#f0f9fe" />
        <circle cx="14.2" cy="12.2" r=".2" fill="#c5d2eb" />
        <circle cx="13.6" cy="12.2" r=".2" fill="#c5d2eb" />
        <circle cx="12.9" cy="12.2" r=".2" fill="#c5d2eb" />
        <circle cx="12.3" cy="12.2" r=".2" fill="#c5d2eb" />
        <circle cx="14.2" cy="12.8" r=".2" fill="#c5d2eb" />
        <circle cx="13.6" cy="12.8" r=".2" fill="#c5d2eb" />
        <circle cx="12.9" cy="12.8" r=".2" fill="#c5d2eb" />
        <circle cx="12.3" cy="12.8" r=".2" fill="#c5d2eb" />
        <circle cx="14.2" cy="13.5" r=".2" fill="#c5d2eb" />
        <circle cx="13.6" cy="13.5" r=".2" fill="#c5d2eb" />
        <circle cx="12.9" cy="13.5" r=".2" fill="#c5d2eb" />
        <circle cx="12.3" cy="13.5" r=".2" fill="#c5d2eb" />
        <path d="M11.7 13.4h-4v-1.6a.6.6 0 0 1 .6-.6h3.4z" fill="#c5d2eb" />
        <rect x="7.9" y="11.4" width="3.1" height="1.5" rx="0" fill="#b7c4de" />
        <rect x="8.1" y="12.1" width="2.5" height=".9" rx=".1" fill="#c5d2eb" />
        <rect x="8" y="12.1" width="2.5" height=".9" rx=".1" fill="#f0f9fe" />
        <circle cx="10" cy="12.6" r=".3" fill="#f8ad3c" />
        <circle cx="8.5" cy="12.6" r=".3" fill="#c5d2eb" />
        <circle cx="10" cy="12.6" r=".2" fill="#236" />
        <circle cx="9.3" cy="12.6" r=".2" fill="#236" />
        <circle cx="8.5" cy="12.6" r=".2" fill="#236" />
        <path
          d="M13.1 11.9H8.7a2.9 2.9 0 0 1 1-2.3l1.4-.2a1.4 1.4 0 0 1 .5 0l1.6.2z"
          fill="#b7c4de"
        />
        <path d="M14.3 11.9a2.9 2.9 0 0 0-1-2.3l-1 2.3z" fill="#c5d2eb" />
        <path
          d="M11.4 11.9H7a2.9 2.9 0 0 1 1-2.3l1.5-.2a1.4 1.4 0 0 1 .4 0l1.6.2z"
          fill="#f0f9fe"
        />
        <path
          d="M12.6 11.9l-1-2.3a2.9 2.9 0 0 0-1 2.3zM9 11.9a4 4 0 0 1 .8-2.5h-.3a3.8 3.8 0 0 0-.8 2.5z"
          fill="#c4d9ef"
        />
        <path d="M14.4 10.7l.7.2-.2.8h-.1l-.6-.1.2-.9z" fill="#7aa9d7" />
        <path d="M14.3 10.7l.7.2-.2.8h-.1l-.6-.1v-.1l.2-.8z" fill="#5e97ce" />
        <path
          d="M14.3 10.8v.3a.4.4 0 0 1 0 .2l-.2.5a.4.4 0 0 0-.1.2v.3a.4.4 0 0 0 .4.4.4.4 0 0 0 .4-.4V12a.4.4 0 0 1 0-.1l.2-.6a.4.4 0 0 0 0-.1v-.3a.4.4 0 0 0-.4-.4.4.4 0 0 0-.3.3z"
          fill="#c5d2eb"
        />
        <path
          d="M14.1 10.8v.3a.4.4 0 0 1 0 .2l-.2.5a.4.4 0 0 0 0 .1v.4a.4.4 0 0 0 .4.4.4.4 0 0 0 .4-.4V12a.4.4 0 0 1 0-.1l.2-.6a.4.4 0 0 0 0-.1v-.3a.4.4 0 0 0-.4-.4.4.4 0 0 0-.4.3z"
          fill="#fff"
        />
        <circle cx="14.2" cy="12.2" r=".2" fill="#c5d2eb" />
        <path d="M14.4 8.8a1 1 0 1 0-.5 1.8l1.4.4.5-1.8z" fill="#5e97ce" />
        <path
          d="M13 9.4a1 1 0 0 1 1.3-.6l1.5.4-.3 1zM14.1 10.6l.8.3-.3.8-.7-.2.2-.9z"
          fill="#7aa9d7"
        />
        <path d="M14 10.6l.8.2-.3.8-.7-.1v-.1l.2-.8z" fill="#5e97ce" />
        <circle cx="14.3" cy="11.2" r=".2" fill="#4184c5" />
        <path d="M12.5 10.1l.7.2-.2.8h-.1l-.6-.1v-.1l.1-.8z" fill="#7aa9d7" />
        <path d="M12.3 10l.7.3-.2.8h-.1L12 11v-.1l.2-.8z" fill="#5e97ce" />
        <path
          d="M12.2 10.8v.3a.4.4 0 0 1 0 .2l-.2.5a.4.4 0 0 0 0 .1v.4a.4.4 0 0 0 .4.4.4.4 0 0 0 .4-.4V12a.8.8 0 0 1 0-.1l.2-.6a.4.4 0 0 0 0-.1v-.3a.4.4 0 0 0-.4-.4.4.4 0 0 0-.4.3z"
          fill="#c5d2eb"
        />
        <path
          d="M12 10.8v.3a.8.8 0 0 1 0 .2l-.2.5a.4.4 0 0 0 0 .1v.4a.4.4 0 0 0 .4.4.4.4 0 0 0 .4-.4V12a.8.8 0 0 1 0-.1l.2-.6a.4.4 0 0 0 0-.1v-.3a.4.4 0 0 0-.3-.4.4.4 0 0 0-.4.3z"
          fill="#fff"
        />
        <path
          d="M12.4 8.2a1 1 0 0 0-1.1.6 1 1 0 0 0 .6 1.2l1.4.4.5-1.7z"
          fill="#4184c5"
        />
        <path d="M11.3 8.8a1 1 0 0 1 1.1-.6l1.4.4-.3.9z" fill="#5e97ce" />
        <path d="M12.2 10l.7.3-.3.8-.7-.1v-.1l.2-.8z" fill="#7aa9d7" />
        <path d="M12 10l.8.2-.3.8-.7-.1v-.1l.2-.8z" fill="#5e97ce" />
        <circle cx="12.3" cy="10.6" r=".2" fill="#4184c5" />
        <rect
          x="11.2"
          y="11.9"
          width="1.2"
          height=".7"
          rx=".1"
          fill="#f0f9fe"
        />
        <circle cx="12.1" cy="12.2" r=".2" fill="#c5d2eb" />
        <path d="M15.7 14.2h2.5v1.1h-2.5v-1z" fill="#236" />
        <path
          d="M18.1 14.2a.3.3 0 0 1 .3.3v.6a.3.3 0 0 1-.3.3z"
          fill="#5e97ce"
        />
        <path
          d="M15.4 15.7a.3.3 0 0 1-.3-.3v-.7a.3.3 0 0 1 .3-.2h.4v-.3a.6.6 0 0 0-.7-.6h-1.4v2.2h2v-.1z"
          fill="#c5d2eb"
        />
        <path d="M12.8 13.6h2v2.2h-2v-2.2z" fill="#f0f9fe" />
        <path
          d="M12.8 14.9h1.5v.6h-1.5V15zM12.8 14h1.5v.6h-1.5V14z"
          fill="#5e97ce"
        />
        <path d="M14.6 14.5h.8v1.2h-.8v-1.2z" fill="#236" />
        <path d="M15.3 14.3h2.4v1.2h-2.4v-1.1z" fill="#7aa9d7" />
        <path
          d="M17.7 15.5a.3.3 0 0 1-.2-.2v-.7a.3.3 0 0 1 .2-.3zM14.6 14.7h1.1v.5h-1.1v-.5z"
          fill="#5e97ce"
        />
        <path
          d="M12.3 16.3a1.6 1.6 0 1 0 0-3.3H8a1.6 1.6 0 0 0 0 3.3"
          fill="#53678e"
        />
        <path
          d="M11.3 16.3a1.6 1.6 0 1 0 0-3.3H7.2a1.6 1.6 0 1 0 0 3.3"
          fill="#236"
        />
        <path
          d="M11.3 13.7a1 1 0 0 1 0 2H7.2a1 1 0 1 1 0-2h4.1m0-.4H7.2a1.3 1.3 0 1 0 0 2.7h4.1a1.3 1.3 0 0 0 0-2.7z"
          fill="#556289"
        />
        <g clip-path="url(#badge1_c)" fill="#236">
          <path d="M11.3 13h3.3v.3h-3.3zM11.3 13.6h3.3v.3h-3.3zM11.3 14.1h3.3v.3h-3.3zM11.3 14.6h3.3v.3h-3.3zM11.3 15.1h3.3v.3h-3.3zM11.3 15.7h3.3v.3h-3.3zM11.3 16.2h3.3v.3h-3.3z" />
        </g>
        <path
          d="M8.4 14.7v-.1h-.2v-.2l.1-.2V14h-.5v-.2l.1-.1-.1-.1h-.4v-.1H7v.2h-.2l-.1-.1h-.2V14l-.2.1h-.2l-.1.1.1.2a.6.6 0 0 0 0 .2H6v.2h.2a.5.5 0 0 0 0 .1v.1l-.1.1v.2h.4V15.6H7v.1h.2v-.2H7.5l.1.2h.2V15H8v-.4h.4z"
          fill="#f8ad3c"
        />
        <circle cx="7.2" cy="14.7" r=".7" fill="#f18c2d" />
        <path
          d="M12.6 14.7v-.1h-.2V14h-.2L12 14V13.6h-.1l-.1.1h-.2v-.2h-.2v.2h-.2l-.1-.1h-.2v.4h-.5-.1V14.3a.6.6 0 0 0 0 .2h-.2v.2h.2a.5.5 0 0 0 0 .1v.4h.4V15.6h.4v.1h.2v-.2h.2l.1.2h.2v-.2h.5l.1-.1v-.4l.2-.2z"
          fill="#f0f9fe"
        />
        <circle cx="11.3" cy="14.7" r=".7" fill="#c5d2eb" />
        <rect x="6.7" y="14.2" width="5.1" height=".9" rx=".5" fill="#f0f9fe" />
        <circle cx="7.2" cy="14.7" r=".3" fill="#f8ad3c" />
        <circle cx="11.3" cy="14.7" r=".3" fill="#f8ad3c" />
        <circle cx="11.3" cy="14.7" r=".2" fill="#236" />
        <circle cx="8.1" cy="14.7" r=".2" fill="#236" />
        <circle cx="8.9" cy="14.7" r=".2" fill="#236" />
        <circle cx="10.4" cy="14.7" r=".2" fill="#236" />
        <circle cx="9.6" cy="14.7" r=".2" fill="#236" />
        <circle cx="7.2" cy="14.7" r=".2" fill="#236" />
        <rect
          x="10.8"
          y="12.3"
          width="2.9"
          height="1.7"
          rx=".8"
          fill="#f18c2d"
        />
        <rect
          x="11.3"
          y="12.3"
          width="2.7"
          height="1.7"
          rx=".8"
          fill="#f8ad3c"
        />
        <rect
          x="11.5"
          y="12.5"
          width="2.2"
          height="1.2"
          rx=".6"
          fill="#f0f9fe"
        />
        <path
          d="M12.1 13.4a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3h.1v.6zM13 13.4a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3h.1v.6z"
          fill="#c5d2eb"
        />
        <circle cx="13.2" cy="13.1" r=".3" fill="#236" />
        <circle cx="12.3" cy="13.1" r=".3" fill="#236" />
        <path
          d="M13 6.7a.8.8 0 0 1 1-.3c.6.1.5.5.4.6a3 3 0 0 1-.3.2h-.5z"
          fill="#ffc800"
        />
        <path
          d="M16.3 9.4a.6.6 0 0 0-.3-.2h-.2l-.5-.2a10 10 0 0 0-2.4-.4 2.6 2.6 0 0 0-1.6.3v-.7a3.6 3.6 0 0 1 0-.4 1.4 1.4 0 0 1 .3-.5 2 2 0 0 1 2-.9h.5l.5.1h.1a2.3 2.3 0 0 1 .7.3.7.7 0 0 1 .2.3 1.8 1.8 0 0 1 .8 1.2c.2.7 0 1.1 0 1z"
          fill="#f8ad3c"
        />
        <path
          d="M16 9.2a.4.4 0 0 0-.2-.1l-.9-.3-.5-.1c.1 0 .3-.5.2-1 0-.5-.4-1.1-.7-1.3H14.5a2.5 2.5 0 0 1 .6.4 2.2 2.2 0 0 1 1 1.4 1.6 1.6 0 0 1-.1 1z"
          fill="#fff"
          opacity=".6"
        />
        <path
          d="M16.3 8.3a2.6 2.6 0 0 0-1-1.4 3.4 3.4 0 0 0-.8-.4h-.1l-.4-.1a1 1 0 0 1 .2.1 2 2 0 0 1 .6 1.2c.1.6 0 1.1-.2 1l.5.2 1 .4c0 .1.3-.4.2-1z"
          fill="#f8ad3c"
        />
        <path
          d="M11.3 9a2.3 2.3 0 0 1 1.6-.4 10 10 0 0 1 2.4.4c.7.2 1 .2 1 .4s.3-.4.2-1a1.8 1.8 0 0 0-.8-1.2 1.9 1.9 0 0 1 .3 1.5l-2.5-.3c-1.5-.2-2.4 0-2.2.6z"
          fill="#f18c2d"
        />
        <path
          d="M17.2 9.5l-.9-.1a1.3 1.3 0 0 0-.3-.2 3.7 3.7 0 0 0-.9-.3 7.2 7.2 0 0 0-1-.2l-.9-.1v-.2a3.1 3.1 0 0 1 1 0 10.2 10.2 0 0 1 2 .4h.3c.7.3.7.4.7.5v.2z"
          fill="#ff9600"
        />
        <path
          d="M16.2 8.8l-.2.4a3.7 3.7 0 0 0-.9-.3 7.2 7.2 0 0 0-1-.2l.1-.3a10.2 10.2 0 0 1 2 .3z"
          fill="#fff"
          opacity=".5"
        />
        <path
          d="M16.5 9a6 6 0 0 0-3.3-.4 13.5 13.5 0 0 1 2 .4 2.6 2.6 0 0 1 1 .5c.3 0 2 0 .3-.5z"
          fill="#cc741d"
        />
        <circle cx="13.7" cy="9.6" r=".9" fill="#4184c5" />
        <circle cx="13.7" cy="9.6" r=".7" fill="#f0f9fe" />
        <circle cx="13.6" cy="9.5" r=".4" fill="#c5d2eb" />
        <circle cx="13.6" cy="9.5" r=".3" fill="#fff" />
        <path d="M13.8 9.4a.3.3 0 0 0-.2-.1.3.3 0 0 0-.2 0z" fill="#454f5a" />
        <circle cx="15.7" cy="10.2" r=".9" fill="#4184c5" />
        <circle cx="15.7" cy="10.2" r=".7" fill="#f0f9fe" />
        <circle cx="15.6" cy="10.1" r=".4" fill="#c5d2eb" />
        <circle cx="15.6" cy="10.1" r=".3" fill="#fff" />
        <path d="M15.8 10a.3.3 0 0 0-.2-.1.3.3 0 0 0-.2 0z" fill="#454f5a" />
        <rect
          x="14.2"
          y="17.5"
          width="6.5"
          height=".7"
          rx=".3"
          fill="#662d91"
        />
        <path fill="#f2f2f2" d="M18 10.6h-1l-2 6.9H20l-2-7z" />
        <path
          fill="#93278f"
          d="M15.8 14.8h3.3l-.5-1.9h-2.3l-.5 1.9zM18.3 12l-.4-1.4H17l-.4 1.4h1.7zM19.4 15.7h-3.8l-.6 1.8H20l-.5-1.8z"
        />
        <path fill="#f2f2f2" d="M6.1 17.9h3.6v.2H6.1z" />
        <rect
          x="7.6"
          y="16.4"
          width="3.2"
          height=".3"
          rx=".1"
          transform="rotate(-109.8 9.2 16.6)"
          fill="#662d91"
        />
        <path fill="#f2f2f2" d="M5.8 17.6v.2l.1.2 3.5-.3-.3-1v-.1l-.4-1-3 2z" />
        <path
          fill="#93278f"
          d="M8 17.8l-.5-1.5-.7.6.3 1h1zM6.4 17.1l-.6.5v.2l.1.2h.8l-.3-.9zM8 16l.6 1.8h.8l-.3-1.1v-.1l-.4-1-.8.4z"
        />
        <path fill="#f0f9fe" d="M14.9 5.3v-1l-.5.3.4.2" />
      </g>
      <circle cx="21.5" cy="11.4" r=".5" fill="#fff" opacity=".4" />
      <circle cx="21.3" cy="13.2" r=".4" fill="#fff" opacity=".3" />
      <circle cx="20.9" cy="14.8" r=".3" fill="#fff" opacity=".2" />
      <circle cx="21.3" cy="9.6" r=".4" fill="#fff" opacity=".5" />
      <circle cx="20.9" cy="8" r=".3" fill="#fff" />
      <circle cx="2.2" cy="11.4" r=".5" fill="#fff" opacity=".4" />
      <circle cx="2.4" cy="13.2" r=".4" fill="#fff" opacity=".5" />
      <circle cx="2.8" cy="14.8" r=".3" fill="#fff" />
      <circle cx="2.4" cy="9.6" r=".4" fill="#fff" opacity=".3" />
      <circle cx="2.8" cy="8" r=".3" fill="#fff" opacity=".2" />
    </g>
  </svg>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/SVG/Badge1.js